import { render } from "./box_probiotic.vue?vue&type=template&id=115cc8a2"
import script from "./box_probiotic.vue?vue&type=script&setup=true&lang=js"
export * from "./box_probiotic.vue?vue&type=script&setup=true&lang=js"

import "./box_probiotic.vue?vue&type=style&index=0&id=115cc8a2&lang=scss&scope=true"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/box_probiotic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "115cc8a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('115cc8a2', __exports__)) {
    console.log('reload')
    api.reload('115cc8a2', __exports__)
  }
  
  module.hot.accept("./box_probiotic.vue?vue&type=template&id=115cc8a2", () => {
    console.log('re-render')
    api.rerender('115cc8a2', render)
  })

}


export default __exports__